var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bank-icon"},[(_vm.bankUrl)?_c('img',{staticClass:"bank-img",attrs:{"src":_vm.bankUrl,"alt":_vm.bank,"width":"160","height":"30"}}):_c('div',{staticClass:"bank-icon-placeholder"},[_vm._v(" "+_vm._s(_vm.bank)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }